import { DefaultTheme, createGlobalStyle, styled } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const GlobalStyle = createGlobalStyle<{ theme: DefaultTheme }>`
  :root {
    --global-navbar-height: ${utils.rem(72.5)};
    --page-margin: ${utils.rem(16)};
  }

  html {
    -webkit-tap-highlight-color: transparent;
  }

  * {
    box-sizing: border-box;
  }
  body {
    background-color: ${({ theme }) =>
      theme.Version === 'light' ? theme.Color.NeutralsFixed.Light : theme.Color.NeutralsFixed.Dark};
    ${({ theme }) => theme.Scrollbar.Default}
  }
  button {
    -webkit-tap-highlight-color: transparent;
  }

  .ant-btn-icon {
    display: inherit;
  }

  #root, html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  #root {
    position: relative;
  }
`;

export const StyledViewer = styled.div`
  height: 100%;
  width: 100%;
`;

export const FullViewPort = styled.div`
  display: flex;
  min-height: 100%;
  min-width: 100%;
`;

export const CanvasWrapper = styled.div`
  display: flex;
  flex: 1;
  grid-area: canvas;
  position: relative;
  transform: scale(1);
`;

export const CenteredFlexContainer = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: center;
  width: 100%;
`;
